import styled, { css } from "styled-components";

export const RevealWrapper = styled.div`
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s ease-out,
    transform 0.8s cubic-bezier(0.2, 0.7, 0.2, 1);
  transition-delay: ${(p) => p.delay || 0}ms;

  &.is-visible {
    opacity: 1;
    transform: none;
  }

  /* As a grid item it must stretch with the row, like the card it wraps. */
  ${(p) =>
    p.stretch &&
    css`
      display: flex;
      flex-direction: column;
      & > * {
        flex: 1 1 auto;
      }
    `}

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
    transition: none;
  }
`;
